export default __webpack_public_path__ + "4386ccdf1e7d10ec772258010ad07c3d.webp";